import {dark} from './dark';
import {light} from './light';

export const mode = {
  dark,
  light
}